var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseTabbedSection',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"default",fn:function(tabbedSectionProps){return [_c(tabbedSectionProps.currentTab.component,{tag:"component",attrs:{"contact-id":_vm.contactId,"contact":_vm.contact},on:{"refresh":_vm.refreshContactMeta}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }